import { render, staticRenderFns } from "./NotFound.vue?vue&type=template&id=e18aaf66&scoped=true&"
import script from "./NotFound.vue?vue&type=script&scoped=true&lang=js&"
export * from "./NotFound.vue?vue&type=script&scoped=true&lang=js&"
import style0 from "./NotFound.vue?vue&type=style&index=0&id=e18aaf66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e18aaf66",
  null
  
)

export default component.exports